import { QueryClient } from '@tanstack/react-query'

import { APP_CONFIG } from '@/config/app.config'
import { HttpError } from '@/lib/http/http-error'

const FINAL_STATUSES = new Set([401, 403, 404, 422])

function shouldRetry(failureCount: number, error: Error): boolean {
  if (error instanceof HttpError && FINAL_STATUSES.has(error.status)) return false
  return failureCount < APP_CONFIG.query.retry
}

/** Create a QueryClient pre-configured with the app's caching defaults. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: APP_CONFIG.query.staleTimeMs,
        gcTime: APP_CONFIG.query.gcTimeMs,
        retry: shouldRetry,
        refetchOnWindowFocus: false,
      },
    },
  })
}
